import { render, staticRenderFns } from "./clemmie.html?vue&type=template&id=5783b8b2&"
import script from "./clemmie.js?vue&type=script&lang=js&"
export * from "./clemmie.js?vue&type=script&lang=js&"
import style0 from "./clemmie.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports